import React, { useState, useCallback } from 'react';
import { Button, Input } from 'reactstrap';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { UPDATE_PRIVACY_POLICY } from '../../mutation/mutation';
import { GET_BOX_PRIVACY_POLICY, GET_USER_FEED } from '../../query/query';

const privacyPolicies = [
  'ONLY_ME',
  'ADMIN_AND_ME',
];

const UpdatePrivacyPolicy = ({ userId, boxId, toggleModifying }) => {
  const [newPrivacyPolicy, setNewPrivacyPolicy] = useState(privacyPolicies[1]);
  const [initialPrivacyPolicy, setInitialPrivacyPolicy] = useState(privacyPolicies[1]);
  const [savUpdatePrivacyPolicy] = useMutation(UPDATE_PRIVACY_POLICY,
    {
      refetchQueries: [
        {
          query: GET_USER_FEED,
          variables: { userId, boxId },
        },
      ],
    });

  const handleAbortChanges = () => {
    setNewPrivacyPolicy(initialPrivacyPolicy);
    toggleModifying();
  };

  const handlePrivacyPolicyChange = useCallback(
    async () => {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm('⚠️ Are you sure you want to change the privacy of all the old user\'s messages for this box ?');
      if (!confirm) {
        return;
      }

      try {
        await savUpdatePrivacyPolicy({ variables: { boxId, userId, newPolicy: newPrivacyPolicy } });
        setInitialPrivacyPolicy(newPrivacyPolicy);
        toggleModifying();
      } catch (e) {
        setNewPrivacyPolicy(initialPrivacyPolicy);
        console.log(e);
      }
    }, [boxId, userId, newPrivacyPolicy],
  );

  return (
    <div>
      <Input
        style={{ width: 300 }}
        type="select"
        onChange={(e) => setNewPrivacyPolicy(e.target.value)}
        value={newPrivacyPolicy}
      >
        { privacyPolicies.map((item) => (
          <option key={item}>{item}</option>
        ))}
      </Input>
      <Button
        type="submit"
        color="danger"
        onClick={handlePrivacyPolicyChange}
      >
        Validate
      </Button>
      <Button
        type="submit"
        color="secondary"
        style={{ marginLeft: 10 }}
        onClick={handleAbortChanges}
      >
        Cancel
      </Button>
    </div>
  );
};

const PrivacyPolicy = ({ userId, boxId }) => {
  const [modifying, setModifying] = useState(false);
  const { data: { savGetPrivacyPolicyForBox: privacyPolicy } = {} } = useQuery(
    GET_BOX_PRIVACY_POLICY,
    {
      fetchPolicy: 'no-cache',
      variables: { userId, boxId },
    },
  );

  return (
    <div>
      {privacyPolicy && (
      <p>{`Default privacy policy for this box: ${privacyPolicy}`}</p>
      )}
      {(modifying)
        ? (
          <UpdatePrivacyPolicy
            toggleModifying={() => setModifying(false)}
            userId={userId}
            boxId={boxId}
          />
        )
        : (
          <Button
            type="submit"
            color="primary"
            onClick={() => setModifying(true)}
          >
            Change privacy of all previous messages
          </Button>
        )}
    </div>
  );
};

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/user-info/privacy-policy.js